export const adminRoutes = [
  {
    path: "/tags",
    name: "tags",
    component: () => import(/* webpackChunkName: "admin" */ "./TagsView.vue"),
  },
];
